import { Injectable } from '@angular/core';
import { BackendModule } from './../modules/backend.module';
import { SessionService } from './session';


@Injectable()
export class AchievementsService {

    achievements=[];

    constructor(public sessionService: SessionService,
        public backendModule: BackendModule) {

    }

    getAchievements() {
        return new Promise((resolve, reject) => {
            // use &reset=1 to test opening on home screen
            this.backendModule.getAPI(`achievements?user_id=${this.sessionService.user.id}`)
                .subscribe(
                    (result: any) => {
                        this.achievements = result;
                        resolve(result)
                    },
                    err => {
                        reject(err)
                    });
        })
    }

}



// WEBPACK FOOTER //
// ./src/services/achievements.ts